import styled from 'styled-components';

import {colors} from 'theme';

export const ChangesTable = styled.table`
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border: 1px solid ${colors.border};
    border-radius: 8px;
    overflow: hidden;

    th,
    td {
        padding: 12px 16px;
        text-align: left;
        overflow-wrap: anywhere;
        white-space: pre-wrap;
        border-bottom: 1px solid ${colors.border};
    }

    th {
        background: ${colors.background};
        color: ${colors.textSecondary};
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.48px;
    }

    td {
        font-size: 14px;
        line-height: 21px;
    }

    tr:last-child td {
        border-bottom: 0;
    }

    td:last-child {
        font-weight: 600;
    }
`;
